export default "__VITE_ASSET__BgV$VrX7__"